export const getUser = (state) => state.user;
export const getSessionData = (state) => state.user?.userData;
export const getUserInfo = (state) => getSessionData(state)?.signInUserSession?.idToken?.payload;
export const getUserFirstName = (state) => getUserInfo(state)?.given_name;
export const getUserLastName = (state) => getUserInfo(state)?.family_name;
export const getUserEmail = (state) => getUserInfo(state)?.email;
export const isSuperUser = (state) => getSessionData(state)?.viewer?.isSuperUser;
export const isTOCSAccepted = (state) => getSessionData(state)?.viewer?.tocAccepted;
export const isAuthenticating = (state) => state.user.authenticating;